// extracted by mini-css-extract-plugin
export default {"modalWrap":"_OLW62GPAS0ZIkZHNB3_","pulse":"a6wbSTahobMZ4fUWh4eM"};